// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"0abc2323","114":"0d79ff74","168":"041b3b20","189":"9ab4495c","531":"69d15a23","551":"02a7f8ff","817":"a20d39e7","891":"e0e61cf0","955":"82893c4e"}[chunkId] + ".chunk.css";
};